module.exports = __webpack_public_path__ + "img/Exportation.8367595b.svg";